module.exports = __webpack_public_path__ + "img/round2.6efbb8fc.svg";